import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { FeatureValues, } from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import isEqual from 'lodash-es/isEqual';
import { map } from 'rxjs/operators';
var FeaturesService = /** @class */ (function (_super) {
    tslib_1.__extends(FeaturesService, _super);
    function FeaturesService(http) {
        var _this = _super.call(this, http, MapperService.tenantFeatureMap) || this;
        _this._endpoint = '/odata/Features';
        return _this;
    }
    FeaturesService.generateFeatureDisplayMap = function (featuresValues) {
        FeaturesService._tenantFeatures = featuresValues;
        var featureDisplayMap = {};
        featuresValues.forEach(function (featureValue) {
            var toRemove = FeaturesService._getFeaturesToRemove(featureValue);
            featureValue.featureSettings.forEach(function (feature) {
                var displayName = feature.displayName;
                featureDisplayMap[displayName] = toRemove.includes(feature.name) || (featureDisplayMap[displayName] &&
                    !isEqual(featureDisplayMap[displayName], feature)) ? null : feature;
            });
        });
        return featureDisplayMap;
    };
    FeaturesService._getFeaturesToRemove = function (featureValue) {
        var featuresToRemove = [];
        // If Insights is not enabled, do not show feature flags for specific Insights features
        var filterInsightsDataFeatures = featureValue.featureSettings.reduce(function (res, feature) {
            return res || (feature.name === 'Insights.Enabled' && !feature.value);
        }, false);
        if (filterInsightsDataFeatures) {
            featuresToRemove = [
                'Insights.QueueSpecificData.Enabled',
                'Insights.QueueOutputData.Enabled',
                'Insights.QueueAnalyticsData.Enabled',
            ];
        }
        return featuresToRemove;
    };
    FeaturesService.prototype.getFeatureFlagsForTenants = function (tenantIds) {
        var _this = this;
        return this._http
            .post(this._endpoint + "/UiPath.Server.Configuration.OData.GetFeatureValuesPerTenantBulk", {
            tenantIds: tenantIds,
        })
            .pipe(map(function (res) {
            var mappedData = _this._mapData(res);
            return mappedData.data;
        }), map(function (res) { return FeaturesService.generateFeatureDisplayMap(res); }));
    };
    FeaturesService.prototype.updateFeatureFlags = function (featuresToBeUpdated, tenantIds) {
        var featureNameByDisplayName = {};
        FeaturesService._tenantFeatures.forEach(function (tenantFeature) {
            tenantFeature.featureSettings.forEach(function (key) {
                featureNameByDisplayName[key.displayName] = key.name;
            });
        });
        var featureSettings = [];
        tenantIds.forEach(function (tenantId) {
            Object.keys(featuresToBeUpdated).forEach(function (featureDisplayName) {
                featureSettings.push({
                    TenantId: tenantId,
                    Name: featureNameByDisplayName[featureDisplayName],
                    Value: featuresToBeUpdated[featureDisplayName] ? FeatureValues.True : FeatureValues.False,
                });
            });
        });
        var reqBody = {
            'feature_settings': featureSettings,
        };
        var reqUrl = this._endpoint + "/UiPath.Server.Configuration.OData.UpdateFeaturesBulk";
        return this._http.post(reqUrl, reqBody);
    };
    FeaturesService._tenantFeatures = [];
    return FeaturesService;
}(ODataService));
export { FeaturesService };
